import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/profile-bg-revert.png")